import { Series } from "../types/Series"
import axios from "axios"
import { url } from "../helper"
import { defineStore } from "pinia"
import { reactive } from "vue"
import { Episode } from "../types/Episode"
import { useI18n } from "vue-i18n"

interface SeriesType {
	series: {
		category: number
		data: Series[]
	}[]
	heroSeries: Series[]
	profileSeriesList: {
		category: number
		data: Series[]
	}[]
	watchingSeriesList: {
		category: number
		data: Series[]
	}[]
	selectedEpisode: Episode
	hoveredSeriesType: string | null
	hoveredSeriesId: number
	top: number
	left: number
}

export const useSeriesStore = defineStore("useSeriesStore", () => {
	const { locale } = useI18n()
	const state = reactive<SeriesType>({
		series: [],
		heroSeries: [],
		profileSeriesList: [],
		watchingSeriesList: [],
		selectedEpisode: {} as Episode,
		hoveredSeriesId: 0,
		hoveredSeriesType: null,
		top: 0,
		left: 0,
	})
	const getHeroSeries = async () => {
		try {
			await axios
				.get(
					`${url}/${locale.value}/jsonapi/node/series?jsonapi_include=1&include=field_image,field_hero_image&filter[langcode]=${locale.value}&filter[field_promote_to_hero]=1&sort=-changed`,
					{}
				)
				.then((res) => {
					state.heroSeries = res.data.data
				})
		} catch (error) {
			console.log(error)
		}
	}

	const setSelectedEpisode = (id: number) => {
		const series = state.series.find((movie) => movie.drupal_internal__nid === id) as Series
		state.selectedEpisode = series.field_episodes.find(
			(ep) => ep.timestamp !== 0 && ep.field_completed === false
		) as Episode
	}

	const getSimilarSeriesByCategory = (categoryIds: Array<number | string>, excludeId?: number | string) => {
		if (!categoryIds || categoryIds.length === 0) return []
		// Convert all to strings for comparison
		const categorySet = new Set(categoryIds.map(String))
		return state.series.filter((m) => {
			if (excludeId && m.drupal_internal__nid === excludeId) return false
			if (!m.field_category) return false
			const movieCategories = Array.isArray(m.field_category) ? m.field_category : [m.field_category]
			// Convert to strings for comparison
			return movieCategories.map(String).some((catId) => categorySet.has(catId))
		})
	}

	const getSeriesByCategory = (id: number) => {
		return state.series.filter((movie) => {
			const categories = movie.field_category || []

			return categories.some((category) => category.meta?.drupal_internal__target_id === id)
		})
	}

	return { state, getHeroSeries, getSimilarSeriesByCategory, getSeriesByCategory, setSelectedEpisode }
})
